<template>
    <div class="boolean-question">
        <label v-bind:class="{ error: valid === false, valid: valid === true }"
            ><slot name="label"></slot
        ></label>
        <div class="options">
            <a
                class="option option-true"
                @click="setValue(1)"
                v-bind:class="{ active: currentValue === 1 }"
                >Sim</a
            >
            <a
                class="option option-false"
                @click="setValue(0)"
                v-bind:class="{ active: currentValue === 0 }"
                >Não</a
            >
        </div>
    </div>
</template>
<script>
export default {
    name: "boolean-question",
    props: {
        value: {
            type: Number,
            default: null,
        },
    },
    data: function () {
        return {
            currentValue: this.value,
            error: null,
            valid: null,
        };
    },
    methods: {
        setValue: function (value) {
            this.currentValue = value;
            this.$emit("change", this.currentValue);
        },
        isValid: function () {
            this.valid = null;
            this.error = null;
            if (this.currentValue === null) {
                this.valid = false;
                this.error = "Selecione uma opção.";
                return false;
            }
            this.valid = true;
            return true;
        },
        getValue: function () {
            return this.currentValue;
        },
        isNull: function () {
            if (this.currentValue === null) {
                return true;
            }
            return false;
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>
